<template>
  <!-- 分割线文本内容
       @author: 王汝鹏
       @date: 2019-9-20
   -->
  <div class="setting-item">
    <el-form-item label="文本"> 
      <el-input v-model="lineText" 
                placeholder="请输入分割线文字内容"></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 分割线文本内容
     *  @description 将 lineText 字段映射到当前 lineText 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-20
     */
    ...mapComputed({
      lineText: { 
        parent: i => i.baseOption,
        attr: "lineText" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingLineText.vue